(function () {
  if (window.freeShippingProgressInitialized) return;
  window.freeShippingProgressInitialized = true;

  const SELECTOR = 'free-shipping-progress';

  class FreeShippingProgress extends HTMLElement {
    connectedCallback() {
      this.messageElement = this.querySelector('[data-free-shipping-message]');
      this.fillElement = this.querySelector('[data-free-shipping-fill]');
      this.renderFromDataset();
    }

    renderFromDataset() {
      this.updateFromCart({
        total_price: Number(this.dataset.cartTotalCents) || 0,
        item_count: Number(this.dataset.itemCount) || 0,
      });
    }

    updateFromCart(cart) {
      const goalCents = Number(this.dataset.goalCents) || 0;
      const totalCents = Math.max(Number(cart?.total_price) || 0, 0);
      const itemCount = Math.max(Number(cart?.item_count) || 0, 0);
      const progress = goalCents > 0 ? Math.min(totalCents / goalCents, 1) : 1;
      const remainingCents = Math.max(goalCents - totalCents, 0);
      const message = this.getMessage(totalCents, itemCount, goalCents, remainingCents);

      this.dataset.cartTotalCents = String(totalCents);
      this.dataset.itemCount = String(itemCount);
      this.dataset.goalReached = totalCents >= goalCents && goalCents > 0 ? 'true' : 'false';

      if (this.messageElement) this.messageElement.textContent = message;
      if (this.fillElement) this.fillElement.style.width = `${progress * 100}%`;

      this.setAttribute('aria-label', message);
      this.querySelector('.free-shipping-progress__bar')?.setAttribute('aria-valuenow', String(totalCents));
      this.querySelector('.free-shipping-progress__bar')?.setAttribute('aria-label', message);
    }

    getMessage(totalCents, itemCount, goalCents, remainingCents) {
      if (totalCents <= 0 || itemCount === 0) {
        return this.dataset.emptyText || '';
      }

      if (totalCents >= goalCents) {
        return this.dataset.successText || '';
      }

      const progressText = this.dataset.progressText || '';
      return progressText.replace('{amount}', this.formatMoney(remainingCents));
    }

    formatMoney(cents) {
      const currency = this.dataset.currency || window.Shopify?.currency?.active || 'EUR';
      const locale = document.documentElement.lang || 'es-ES';
      const hasDecimals = cents % 100 !== 0;

      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    }
  }

  if (!customElements.get(SELECTOR)) {
    customElements.define(SELECTOR, FreeShippingProgress);
  }

  const manager = {
    refreshTimer: null,
    cartUpdateUnsubscriber: null,

    init() {
      this.bindThemeEvents();
      this.renderFromCurrentMarkup();
      this.scheduleFetch(0);
    },

    bindThemeEvents() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate && !this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.scheduleFetch());
      }

      document.addEventListener('cart-drawer:open', () => this.scheduleFetch(0));
      document.addEventListener('shopify:section:load', () => this.scheduleFetch(0));
      window.addEventListener('pageshow', () => this.scheduleFetch(0));
    },

    renderFromCurrentMarkup() {
      document.querySelectorAll(SELECTOR).forEach((element) => {
        if (typeof element.renderFromDataset === 'function') {
          element.renderFromDataset();
        }
      });
    },

    scheduleFetch(delay = 80) {
      window.clearTimeout(this.refreshTimer);
      this.refreshTimer = window.setTimeout(() => this.fetchCart(), delay);
    },

    fetchCart() {
      const cartUrl = window.routes?.cart_url || '/cart';

      fetch(`${cartUrl}.js`, {
        headers: {
          Accept: 'application/json',
        },
      })
        .then((response) => response.json())
        .then((cart) => {
          document.querySelectorAll(SELECTOR).forEach((element) => {
            if (typeof element.updateFromCart === 'function') {
              element.updateFromCart(cart);
            }
          });
        })
        .catch((error) => {
          console.error('Free shipping progress could not refresh.', error);
        });
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => manager.init(), { once: true });
  } else {
    manager.init();
  }
})();
